<template>
  <div id="return_step_2">
    <div class="top_title">
      <!-- <p>{{ $t('views.cart.deliveryinfo.5916') }}</p> -->
      <p>{{ `반품수거 주소지` }}</p>
    </div>
    <ul class="form_wrap">
      <SearchAddressModal
        v-if="showAddressModal"
        @complete="onComplete"
        @close="toggleAddressModal"
      />
      <template>
        <template>
          <li class="return_name">
            <div class="left_box">
              <span class="sub_title">
                {{ $t('views.cart.deliveryinfo.6751') }}
              </span>
            </div>
            <div class="right_box">
              <div class="input_wrap">
                <input
                  v-model="returnName"
                  class="input_t"
                  type="text"
                  name="name"
                />
              </div>
            </div>
          </li>
          <li class="join_address">
            <div class="left_box">
              <span class="sub_title">
                {{ $t('views.cart.deliveryinfo.7870') }}
              </span>
            </div>

            <!-- Korean Zonecode Finder -->
            <div class="right_box">
              <div class="input_wrap">
                <input
                  v-model="address.zonecode"
                  class="input_t postcode"
                  type="text"
                  name="zonecode"
                  :placeholder="$t('views.cart.deliveryinfo.8185')"
                  readonly
                />
                <div class="btn_wrap">
                  <a class="box_btn dull" @click="toggleAddressModal">
                    <span class="an_t">{{
                      $t('views.cart.deliveryinfo.4272')
                    }}</span>
                  </a>
                </div>
              </div>

              <div class="input_wrap">
                <div class="fl">
                  <input
                    v-model="address.roadAddress"
                    class="input_t"
                    type="text"
                    name="roadAddress"
                    :placeholder="$t('views.cart.deliveryinfo.8478')"
                  />
                </div>
                <div class="fl">
                  <input
                    v-model="address.addressDetail"
                    class="input_t"
                    type="text"
                    name="addressDetail"
                    :placeholder="$t('views.cart.deliveryinfo.3109')"
                  />
                </div>
              </div>
            </div>
          </li>
          <!-- MOBILE PHONE DETAILS -->
          <li class="join_phone">
            <div class="left_box">
              <span class="sub_title align_top">
                {{ $t('views.cart.deliveryinfo.7231') }}
              </span>
            </div>

            <!-- Country Code delete -->

            <!-- Mobile Phone Number -->
            <div class="right_box phone_wrap">
              <div class="input_wrap">
                <input
                  v-model="selectedMobilePrefix"
                  class="input_t"
                  type="number"
                  maxlength="3"
                  placeholder="000"
                />
              </div>
              <div class="input_wrap ml-1">
                <input
                  v-model="mobileNumber1"
                  class="input_t"
                  type="number"
                  pattern="/^-?\d+\.?\d*$/"
                  onkeypress="if(this.value.length==4) return false;"
                  name="mobileNumber1"
                  maxlength="4"
                  placeholder="0000"
                />
              </div>
              <div class="input_wrap">
                <input
                  v-model="mobileNumber2"
                  class="input_t"
                  type="number"
                  pattern="/^-?\d+\.?\d*$/"
                  onkeypress="if(this.value.length==4) return false;"
                  name="mobileNumber2"
                  maxlength="4"
                  placeholder="0000"
                />
              </div>
            </div>
          </li>

          <!-- Landline Phone Number -->
          <li class="join_phone">
            <div class="left_box">
              <span class="sub_title">
                {{ $t('views.cart.deliveryinfo.9778') }}
              </span>
            </div>
            <div class="right_box phone_wrap">
              <div class="input_wrap">
                <input
                  v-model="selectedPhonePrefix"
                  class="input_t"
                  type="number"
                  maxlength="3"
                  placeholder="000"
                />
              </div>
              <div class="input_wrap ml-1">
                <input
                  v-model="phoneNumber1"
                  class="input_t"
                  type="number"
                  pattern="/^-?\d+\.?\d*$/"
                  onkeypress="if(this.value.length==4) return false;"
                  name="phoneNumber1"
                  placeholder="0000"
                  maxlength="4"
                />
              </div>
              <div class="input_wrap">
                <input
                  v-model="phoneNumber2"
                  class="input_t"
                  type="number"
                  pattern="/^-?\d+\.?\d*$/"
                  onkeypress="if(this.value.length==4) return false;"
                  name="phoneNumber2"
                  placeholder="0000"
                  maxlength="4"
                />
              </div>
            </div>
          </li>
          <li>
            <div class="left_box">
              <span class="sub_title">
                {{ $t('views.cart.deliveryinfo.7210') }}
              </span>
            </div>
            <ul class="join_check" data-detail="check_fl">
              <div class="text_label">
                <label>
                  <input
                    v-model="isDefaultAddress"
                    type="radio"
                    name="isDefaultAddress"
                    :value="true"
                  />
                  <em></em>
                  <span>{{ $t('views.cart.deliveryinfo.5149') }}</span>
                </label>
              </div>
              <div class="text_label">
                <label>
                  <input
                    v-model="isDefaultAddress"
                    type="radio"
                    name="isDefaultAddress"
                    :value="false"
                  />
                  <em></em>
                  <span>{{ $t('views.cart.deliveryinfo.8747') }}</span>
                </label>
              </div>
            </ul>
          </li>
        </template>
      </template>
    </ul>
    <div class="stage_btn_wrap">
      <div class="prev_btn cursor" @click="$emit('prevCall', 2)">이전으로</div>
      <div class="next_btn cursor" @click="emitCall">환불금액 확인</div>
    </div>
  </div>
</template>

<script>
import SearchAddressModal from '@/components/common/SearchAddressModal.vue'
export default {
  name: 'Returnstep2',
  components: {
    SearchAddressModal
  },
  data() {
    return {
      isDefaultAddress: true,
      showAddressModal: '',
      returnName: '',
      // 핸드폰
      selectedMobilePrefix: '',
      mobileNumber1: '',
      mobileNumber2: '',
      // 전화번호
      selectedPhonePrefix: '',
      phoneNumber1: '',
      phoneNumber2: '',
      address: {
        zonecode: '',
        roadAddress: '',
        addressDetail: ''
      }
    }
  },
  computed: {
    setReturnMobile() {
      if (
        !this.selectedMobilePrefix ||
        !this.mobileNumber1 ||
        !this.mobileNumber2
      ) {
        return false
      } else {
        return (
          this.selectedMobilePrefix + this.mobileNumber1 + this.mobileNumber2
        )
      }
    },
    setReturnPhone() {
      if (
        !this.selectedPhonePrefix ||
        !this.phoneNumber1 ||
        !this.phoneNumber2
      ) {
        return false
      } else {
        return this.selectedPhonePrefix + this.phoneNumber1 + !this.phoneNumber2
      }
    },
    setReturnAddress() {
      if (
        !this.address.zonecode ||
        !this.address.roadAddress ||
        !this.address.addressDetail
      ) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    toggleAddressModal() {
      this.showAddressModal = !this.showAddressModal
    },
    onComplete(data) {
      this.address.zonecode = data.zonecode
      this.address.roadAddress = data.roadAddress
      this.showAddressModal = false
    },
    async emitCall() {
      if (
        !this.setReturnReason ||
        !this.setReturnPhone ||
        !this.returnName ||
        !this.setReturnAddress
      ) {
        return
      }
      const {
        setReturnMobile,
        setReturnPhone,
        setReturnAddress,
        returnName
      } = this
      this.$emit('nextCall', {
        stageNo: 2,
        stageVal: {
          setReturnMobile,
          setReturnPhone,
          setReturnAddress,
          returnName
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.stage_btn_wrap {
  display: flex;
  justify-content: center;
  margin: 40px 0px 64px;
  div {
    background-color: #778899;
    width: 240px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
  }
  div + div {
    margin-left: 8px;
    background-color: #125c83;
  }
}
.select_area,
.select_item,
.select_option {
  width: 100%;
}
.left_box {
  width: 100px;
  height: 48px;
  line-height: 48px;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
}
.right_box {
  width: 100%;
}
.phone_wrap {
  display: flex;
  .input_wrap {
    margin-right: 12px;
    width: 157px;
  }
  .input_wrap:first-child {
    width: 130px;
  }
}
.join_phone > div:last-child {
  margin-top: 0;
  margin-left: 0px;
}
.top_title {
  padding: 17px 40px;
  background: #f0f5fa;
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  color: #222;
}
.input_t {
  width: 100%;
}
.select_area {
  margin-top: 10px;
  margin-bottom: 10px;
}

.join_address .fl {
  width: 100%;
}
.join_address .fl + .fl {
  margin: 12px 0px 0px;
}
.form_wrap > li + li {
  margin-top: 40px;
}
.input_prefix {
  width: 110px;
}
.form_wrap {
  padding: 40px;
  border-bottom: 1px solid #d6e7f1;
}
.country_list {
  width: 100%;
  margin-bottom: 10px;
}

.country_dropdown {
  width: 100%;
}

.inputMessage {
  width: 100% !important;
}
.join_check {
  display: flex;
  align-items: center;
  padding-top: 8px;
}
.join_check .text_label input + em:before {
  position: absolute;
  display: inline-block;
  left: 50%;
  top: 50%;
  margin-top: -6px;
  margin-left: -6px;
  width: 10px;
  height: 10px;
  border: 1px solid #b4bec8;
  border-radius: 50%;
  content: '';
  z-index: 10;
}
.join_check .text_label input[type='radio'] + em {
  width: 24px;
  height: 24px;
  background-color: #f0f5fa;
  margin: 0;
  border-radius: 50%;
  background-image: none;
}
.join_check .text_label input[type='radio']:checked + em:after {
  left: 50%;
  top: 50%;
  margin-top: -6px;
  margin-left: -6px;
  width: 12px;
  height: 12px;
  background: #36a5c2;
  border-radius: 50%;
  background-image: none;
}
.name_field {
  display: flex;
}
.form_wrap > li {
  display: flex;
}
</style>
